<template>
  <v-menu
    lazy
    :close-on-content-click="false"
    v-model="open"
    transition="scale-transition"
    offset-y
    full-width
    :nudge-right="40"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="placeholder"
        v-model="date"
        prepend-icon="event"
        readonly
        hide-details
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      @input="open = false"
      locale="ru-RU"
      :type="type"
      no-title
      scrollable
    ></v-date-picker>
  </v-menu>
</template>
<script>
export default {
  name: 'r-calendar',
  data() {
    return {
      date: this.value,
      open: false,
    }
  },
  props: {
    value: {
      type: String,
      default: new Date().toISOString().substr(0, 10),
    },
    placeholder: {
      type: String,
      default: 'Дата',
    },
    type: {
      type: String,
      default: 'date',
    },
  },
  watch: {
    value() {
      this.date = this.value
    },
    date() {
      this.$emit('input', this.date)
    },
  },
}
</script>
<style scoped>
</style>